// extracted by mini-css-extract-plugin
module.exports = {"section":"D_section__6L1U_"};